/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Return_Decision_ConfirmInputs */

const vi_carrier_return_decision_confirm = /** @type {(inputs: Carrier_Return_Decision_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gửi phản hồi`)
};

/**

* @param {Carrier_Return_Decision_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_return_decision_confirm = /** @type {((inputs?: Carrier_Return_Decision_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Return_Decision_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_return_decision_confirm(inputs)
});